import { render, staticRenderFns } from "./BaseSwiper.vue?vue&type=template&id=1b70b94c&scoped=true"
import script from "./BaseSwiper.vue?vue&type=script&lang=js"
export * from "./BaseSwiper.vue?vue&type=script&lang=js"
import style0 from "./BaseSwiper.vue?vue&type=style&index=0&id=1b70b94c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70b94c",
  null
  
)

export default component.exports